import { Skeleton } from "@/components/ui/skeleton";

export const GreetingBannerSkeleton = () => (
  <div className="mb-6 ios-card-elevated p-4 animate-pulse">
    <div className="flex items-center gap-4">
      <Skeleton className="w-14 h-14 rounded-2xl" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-4 w-48" />
      </div>
      <Skeleton className="h-9 w-20 rounded-full" />
    </div>
  </div>
);

export const FeaturesBannerSkeleton = () => (
  <div className="mb-6 grid grid-cols-3 gap-2">
    {[1, 2, 3].map((i) => (
      <div key={i} className="ios-card p-3 flex flex-col items-center gap-2">
        <Skeleton className="w-8 h-8 rounded-lg" />
        <Skeleton className="h-3 w-16" />
      </div>
    ))}
  </div>
);

export const PromoGridSkeleton = () => (
  <section className="mb-6">
    <Skeleton className="h-4 w-20 mb-3 ml-4" />
    <div className="grid grid-cols-2 gap-3">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="ios-card p-4 space-y-3">
          <Skeleton className="w-10 h-10 rounded-xl" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-32" />
        </div>
      ))}
    </div>
  </section>
);

export const ServicesListSkeleton = () => (
  <section className="mb-6">
    <Skeleton className="h-4 w-24 mb-3 ml-4" />
    <div className="ios-card overflow-hidden">
      {[1, 2, 3].map((i) => (
        <div key={i} className="px-4 py-3 flex items-center gap-3 border-b border-border/50 last:border-0">
          <Skeleton className="w-10 h-10 rounded-xl" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-3 w-40" />
          </div>
          <Skeleton className="w-5 h-5 rounded" />
        </div>
      ))}
    </div>
  </section>
);

export const QuickLinksSkeleton = () => (
  <section className="mb-6">
    <Skeleton className="h-4 w-32 mb-3 ml-4" />
    <div className="grid grid-cols-4 gap-2">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="flex flex-col items-center gap-2 p-3">
          <Skeleton className="w-14 h-14 rounded-2xl" />
          <Skeleton className="h-3 w-12" />
        </div>
      ))}
    </div>
  </section>
);

export const IndexPageSkeleton = () => (
  <div className="rounded-3xl p-4 ios-glass-frosted border border-white/30 dark:border-white/15">
    <GreetingBannerSkeleton />
    <FeaturesBannerSkeleton />
    <PromoGridSkeleton />
    <ServicesListSkeleton />
    <QuickLinksSkeleton />
  </div>
);
